import React, {useEffect} from 'react';
import {
  Image,
  NativeScrollEvent,
  NativeSyntheticEvent,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {TabView} from '@rneui/themed';
import {createStyles} from '../../../utils/createStyles';
import {getOCRRecordList, OCRRecordListData} from '../../../API/ocr';
import {useBoolean, useInfiniteScroll, useMount} from 'ahooks';
import {useNavigation} from '@react-navigation/native';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../../components/Loading/GlobalLoading';
import {getChatList, GetChatListData} from '../../../API/chat';

function TakePhotoRecordList(): React.JSX.Element {
  const pageSize = 3;
  const {navigate} = useNavigation();
  const {data, noMore, loading, loadMore, loadingMore} = useInfiniteScroll<{
    list: Array<OCRRecordListData>;
  }>(d => {
    const page = d ? Math.ceil(d.list.length / pageSize) + 1 : 1;
    return getOCRRecordList({
      page: page - 1,
      size: pageSize,
    }).then(res => {
      return {
        list: res.data.content,
      };
    });
  });
  useMount(() => {
    // loadMore();
  });
  useEffect(() => {
    if (loadingMore || loading) {
      showGlobalLoading({
        text: '加载中',
      });
    } else {
      hideGlobalLoading();
    }
  }, [loadingMore, loading]);
  const onMomentumScrollEnd = (
    event: NativeSyntheticEvent<NativeScrollEvent>,
  ) => {
    const offSetY = event.nativeEvent.contentOffset.y; // 获取滑动的距离
    const contentSizeHeight = event.nativeEvent.contentSize.height; // scrollView  contentSize 高度
    const oriageScrollHeight = event.nativeEvent.layoutMeasurement.height; // scrollView高度
    if (offSetY + oriageScrollHeight >= contentSizeHeight - 1) {
      if (!noMore && !loading) {
        loadMore();
      }
    }
  };
  const toOcrInfo = (ocrRecordId: number) => {
    navigate('OCRSuccess', {recordId: ocrRecordId});
  };
  return (
    <ScrollView onScrollEndDrag={onMomentumScrollEnd}>
      {data?.list.map(item => {
        return (
          <View key={item.ocrDate} style={takePhotoStyles.recordItem}>
            <View style={takePhotoStyles.date}>
              <Image
                style={takePhotoStyles.dateIcon}
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/%E8%B7%AF%E5%BE%84.png',
                }}
              />
              <Text>{item.ocrDate}</Text>
            </View>
            <View style={takePhotoStyles.imgsWrap}>
              {item.records.map((img, index) => {
                return (
                  <TouchableOpacity
                    activeOpacity={0.6}
                    key={index}
                    onPress={() => toOcrInfo(img.ocrRecordId)}
                    style={takePhotoStyles.imgView}>
                    <Image
                      resizeMode={'contain'}
                      style={{height: '100%', width: '100%'}}
                      source={{
                        uri: img.base64Img,
                      }}
                    />
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>
        );
      })}
    </ScrollView>
  );
}

const takePhotoStyles = createStyles({
  recordItem: {
    flexDirection: 'column',
    marginBottom: '2.5rem',
  },

  date: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  dateIcon: {
    marginRight: '0.8rem',
    width: '1.35rem',
    aspectRatio: 1,
  },
  imgsWrap: {
    marginTop: '1.2rem',
    padding: '1.4rem',
    paddingRight: '0.2rem',
    paddingBottom: '0.2rem',
    backgroundColor: '#E5EDFC',
    borderRadius: '0.75rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  imgView: {
    height: '15.75rem',
    width: '12.1rem',
    borderRadius: '0.5rem',
    backgroundColor: '#fff',
    marginRight: '1.2rem',
    marginBottom: '1.2rem',
  },
});

function ChatRecordList(): React.JSX.Element {
  const pageSize = 6;
  const {navigate} = useNavigation();
  const {data, noMore, loading, loadMore, loadingMore} = useInfiniteScroll<{
    list: Array<GetChatListData>;
  }>(d => {
    const page = d ? Math.ceil(d.list.length / pageSize) + 1 : 1;
    return getChatList({
      page: page - 1,
      size: pageSize,
    }).then(res => {
      return {
        list: res.data.content,
      };
    });
  });
  useEffect(() => {
    if (loadingMore || loading) {
      showGlobalLoading({
        text: '加载中',
      });
    } else {
      hideGlobalLoading();
    }
  }, [loadingMore, loading]);
  const onMomentumScrollEnd = (
    event: NativeSyntheticEvent<NativeScrollEvent>,
  ) => {
    const offSetY = event.nativeEvent.contentOffset.y; // 获取滑动的距离
    const contentSizeHeight = event.nativeEvent.contentSize.height; // scrollView  contentSize 高度
    const oriageScrollHeight = event.nativeEvent.layoutMeasurement.height; // scrollView高度
    if (offSetY + oriageScrollHeight >= contentSizeHeight - 1) {
      if (!noMore && !loading) {
        loadMore();
      }
    }
  };
  const toChatInfo = (conversationId: string) => {
    navigate('ChatRecordInfo', {chatRecordId: conversationId});
  };
  return (
    <ScrollView onScrollEndDrag={onMomentumScrollEnd}>
      {data?.list.map(item => (
        <TouchableOpacity
          key={item.conversationId}
          activeOpacity={0.6}
          onPress={() => toChatInfo(item.conversationId)}
          style={chatRecordStyles.chatItemWrap}>
          <View style={chatRecordStyles.infoWrap}>
            <View style={chatRecordStyles.timeWrap}>
              <Image
                style={chatRecordStyles.timeIcon}
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/%E8%B7%AF%E5%BE%84.png',
                }}
              />
              <Text style={chatRecordStyles.timeText}>{item.chatTime}</Text>
              {/*<Image*/}
              {/*  style={chatRecordStyles.delIcon}*/}
              {/*  source={{*/}
              {/*    uri: 'https://media.oss.leziedu.com/webapp/classroom/%E7%BB%84%201007.png',*/}
              {/*  }}*/}
              {/*/>*/}
            </View>
            <View style={chatRecordStyles.titleWrap}>
              <Text style={chatRecordStyles.titleText}>与{item.app}的聊天</Text>
            </View>
          </View>
          <View>
            <Image
              style={chatRecordStyles.rightIcon}
              source={{
                uri: 'https://media.oss.leziedu.com/webapp/classroom/%E8%B7%AF%E5%BE%84%20230.png',
              }}
            />
          </View>
        </TouchableOpacity>
      ))}
      <Text style={chatRecordStyles.des}>说明：仅记录账号登录期间对话</Text>
    </ScrollView>
  );
}

const chatRecordStyles = createStyles({
  chatItemWrap: {
    borderRadius: '1rem',
    paddingLeft: '3.1rem',
    paddingRight: '2.9rem',
    width: '100%',
    height: '7.7rem',
    backgroundColor: '#ECF2FF',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1.2rem',
  },
  rightIcon: {
    width: '0.8rem',
    height: undefined,
    aspectRatio: 0.6,
  },
  infoWrap: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  timeWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  timeIcon: {
    width: '1.25rem',
    aspectRatio: 1,
    marginRight: '0.65rem',
  },
  timeText: {
    fontSize: '1.3rem',
    color: '#5275E4',
  },
  delIcon: {
    width: '1.35rem',
    aspectRatio: 1,
    marginLeft: '2.4rem',
  },
  titleWrap: {
    marginLeft: '1.8rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleText: {
    fontSize: '1.5rem',
    color: '#3D3D3D',
  },
  des: {
    marginTop: '1.8rem',
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#999999',
  },
});

export default function RecordIndex(): React.JSX.Element {
  const [index, setIndex] = React.useState(1);
  const [showIndex2, {setTrue}] = useBoolean(false);
  useEffect(() => {
    if (index === 1) {
      setTrue();
    }
  }, [index, setTrue]);
  return (
    <View style={styles.flex1}>
      <View style={styles.tabView}>
        {/*<TouchableOpacity*/}
        {/*  activeOpacity={0.6}*/}
        {/*  style={[*/}
        {/*    styles.commonButton,*/}
        {/*    index === 0 ? styles.ActiveButton : styles.inActiveButton,*/}
        {/*  ]}*/}
        {/*  onPress={() => setIndex(0)}>*/}
        {/*  <Text*/}
        {/*    style={[index === 0 ? styles.btText : styles.inActiveButtonBtText]}>*/}
        {/*    拍照记录*/}
        {/*  </Text>*/}
        {/*</TouchableOpacity>*/}
        <TouchableOpacity
          activeOpacity={0.6}
          style={[
            styles.commonButton,
            styles.positionRight,
            index === 1 ? styles.ActiveButton : styles.inActiveButton,
          ]}
          onPress={() => setIndex(1)}>
          <Text
            style={index === 1 ? styles.btText : styles.inActiveButtonBtText}>
            对话记录
          </Text>
        </TouchableOpacity>
      </View>
      <TabView value={index} onChange={setIndex} animationType="timing">
        <TabView.Item style={styles.contentWrap}>
          <TakePhotoRecordList />
        </TabView.Item>
        <TabView.Item style={styles.chatContentWrap}>
          {showIndex2 ? <ChatRecordList /> : null}
        </TabView.Item>
      </TabView>
    </View>
  );
}

const styles = createStyles({
  flex1: {
    flex: 1,
    backgroundColor: '#fff',
  },
  tabView: {
    height: '3.85rem',
    flexDirection: 'row',
    justifyContent: 'center',
    borderBottomLeftRadius: '2.1rem',
    borderBottomRightRadius: '2.1rem',
  },
  commonButton: {
    position: 'relative',
    width: '22.75rem',
    height: '3.85rem',
    borderBottomLeftRadius: '2.1rem',
    borderBottomRightRadius: '2.1rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  positionRight: {
    right: '3.25rem',
  },
  inActiveButton: {
    backgroundColor: '#E5EDFC',
    marginRight: 0,
    zIndex: 1,
  },
  ActiveButton: {
    backgroundColor: '#6658FF',
    zIndex: 2,
  },
  inActiveButtonBtText: {
    color: '#847DD6',
    fontSize: '1.6rem',
  },
  btText: {
    fontSize: '1.6rem',
    color: '#fff',
  },
  contentWrap: {
    width: '100%',
    marginTop: '2.3rem',
    paddingHorizontal: '2.5rem',
  },
  chatContentWrap: {
    flex: 1,
    marginTop: '2.3rem',
    marginLeft: '20.5rem',
    marginRight: '20.5rem',
    paddingHorizontal: '2.5rem',
  },
});
